import React from 'react'
import back from "../assets/back.png"
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import down from "../assets/down.png"
import round from "../assets/round (2).png"
import { useNavigate } from 'react-router-dom'
import info from "../assets/info.png"

function Payment() {
    const Navigate = useNavigate()
    const movepage = () => {
        Navigate("/wallet")
    }
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5", height: "100vh" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div  mb-4  pt-2 ps-3 pe-3 pb-5' style={{ backgroundColor: "white", marginTop: "85px", width: "100%" }}>
                    <div className='container ps-5 pe-5 wallet_container'>
                        <div className='d-flex gap-2 align-items-center mt-5' onClick={movepage} style={{ cursor: "pointer" }}>
                            <img src={back} />
                            <p className='plan_heading'>Select a Plan</p>
                        </div>
                        <div className='d-flex gap-4 flex-wrap justify-content-between'>

                            <div className='card1 mt-4 '>
                                <p className='card_main mb-5'>Checkout</p>
                                <p className='card_main2 ms-3'>Professional</p>
                                <div className='d-flex justify-content-between ps-3 pe-3 mt-4 pb-3' style={{ borderBottom: "1px solid rgba(229, 233, 243, 1)" }}>
                                    <p className='card_main2'>5 Social Accounts</p>
                                    <p className='card_main2'>$60</p>
                                </div>
                                <div className='d-flex justify-content-between pt-4 ps-3 pe-3'>
                                    <p className='card_main3'>Total</p>
                                    <p className='card_main3'>$60</p>
                                </div>
                                <div className='d-flex gap-2 align-items-start ps-3 pe-3 mt-4'>
                                    <input type="checkbox" className='input_check_box' />
                                    <p className='confirm_text mb-0'>By confirming the order, I accept the <span className='confirm_textspan'> terms of
                                        the user agreement.</span></p>
                                </div>

                            </div>

                            <div className='card2 mt-4 ps-3 pe-3'>
                                <p className='card_main ms-0 mb-5'>Payment Details</p>
                                <p className='card_main2 ms-3'>Payment Method</p>
                                <div className='ps-2 pe-2' style={{ position: "relative", maxWidth: "600px" }}>
                                    <input className='input2 w-100 first_input' placeholder='Master Card' />
                                    <div style={{ position: "absolute", top: "5px", right: "15px" }}>
                                        <img src={down} />
                                    </div>
                                    <div style={{ position: "absolute", top: "5px", left: "15px" }}>
                                        <img style={{ height: "20px", width: "35px" }} src={round} />
                                    </div>
                                </div>
                                <p className='card_main2 ms-3 mt-3'>Expiry Date</p>
                                <div className='ps-2 pe-2' style={{ position: "relative", maxWidth: "600px" }}>
                                    <input className='input2 w-100' placeholder='Adam Person' />
                                </div>
                                <p className='card_main2 ms-3 mt-3'>Card Number</p>
                                <div className='ps-2 pe-2' style={{ position: "relative", maxWidth: "600px" }}>
                                    <input className='input2 w-100' placeholder='xxxx-xxxx-xxxx-xxxx' />
                                </div>
                                <div className='d-flex gap-2 payment_flex'>
                                    <div className='payment1'>
                                        <p className='card_main2 ms-3 mt-3'>Expiry Date</p>
                                        <input className='input2 w-100' placeholder='mm/yy' />
                                    </div>
                                    <div className='payment2'>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <p className='card_main2 ms-3 mt-3'>CVC</p>
                                            <img src={info} />
                                        </div>
                                        <input className='input2 w-100' placeholder='***' />
                                    </div>
                                </div>
                                <div className='d-flex gap-2 align-items-start ps-3 pe-3 mt-4'>
                                    <input type="checkbox" className='input_check_box' />
                                    <p className='confirm_text mb-0'>Remember this Card Information</p>
                                </div>
                                <div className='d-flex justify-content-center' style={{ marginTop: "20px" }}>
                                    <button className='select_btn' style={{ backgroundColor: "rgba(45, 156, 219, 1)", color: "white" }}>Pay Now</button>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>







    </>

    )
}

export default Payment